<template>
  <form>
    <br />
    <center>
      <h1 class="title">Question {{ startStep + activeStep }}</h1>
    </center>
    <br />
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <b-progress size="is-small" type="is-primary" :value="progressValue" />
      </div>
    </div>
    <center>
      <h6 class="subtitle is-6"><strong v-html="activeQuestion"></strong></h6>
    </center>
    <br />
    <div v-if="activeStep === 0" :type="noMode1Selected ? 'is-danger' : ''">
      <div class="columns is-multiline is-centered">
        <div
          v-for="(mode, index) in TRAVELS_MODES"
          :key="index"
          class="column is-3"
        >
          <button
            class="button is-mode-deplacement is-fullwidth"
            type="button"
            :class="{
              'is-primary is-light': buffer.hasMode(mode),
              'is-danger': noMode1Selected
            }"
            @click="selectMode1(mode)"
          >
            <b-icon
              :pack="modeIconPack(mode)"
              :icon="modeIcon(mode)"
              style="padding-right: 20px"
            />
            <span> {{ $t(mode) }} </span>
          </button>
        </div>
      </div>
      <br />
    </div>
    <div v-if="activeStep === 1">
      <b-notification :closable="false">
        {{ $t('compCarbonFormsCommutesForm.header-1') }}
        <a
          target="_blank"
          class="link"
          href="https://www.openstreetmap.org/directions"
          >openstreetmap</a
        >.
        {{ $t('compCarbonFormsCommutesForm.header-2') }}
        <br />
        {{ $t('compCarbonFormsCommutesForm.header-3') }}
      </b-notification>
      <b-notification
        v-for="(section, index) in buffer.sections.filter(
          (section) => !section.isDay2
        )"
        :type="
          errors.has(section.mode + '1') ||
          errors.has(section.mode + '.engine1') ||
          errors.has(section.mode + '.pooling1')
            ? 'is-danger'
            : ''
        "
        :closable="false"
        :key="index"
      >
        <b-field
          :label="
            $t('compCarbonFormsCommutesForm.distance-in') +
            ' ' +
            $t(section.mode).toLowerCase() +
            ' (' +
            $t('compCarbonFormsCommutesForm.km-day') +
            ')' +
            ' *'
          "
          :type="{ 'is-danger': errors.has(section.mode + '1') }"
          :message="errors.first(section.mode + '1')"
        >
          <b-input
            :name="section.mode + '1'"
            @input="$emit('input', buffer)"
            v-validate="{
              required: true,
              numeric: true,
              min_value: 1,
              max_value: modeMaxDistance(section.mode)
            }"
            min="0"
            :icon="modeIcon(section.mode)"
            :icon-pack="modeIconPack(section.mode)"
            type="number"
            :placeholder="0"
            v-model="section.distance"
          />
        </b-field>
        <b-field
          v-if="section.mode === 'car'"
          :label="$t('compCarbonFormsCommutesForm.engine') + ' *'"
          :type="{ 'is-danger': errors.has(section.mode + '.engine1') }"
          :message="errors.first(section.mode + '.engine1')"
        >
          <b-select
            :name="section.mode + '.engine1'"
            v-model="section.engine"
            @input="$emit('input', buffer)"
            v-validate="'required'"
            :placeholder="$t('compCarbonFormsCommutesForm.engine') + ' *'"
            :type="errors.has(section.mode + '.engine1') ? 'is-danger' : ''"
            expanded
          >
            <option
              :value="engine"
              v-for="(engine, index) in engines"
              :key="index"
            >
              {{ $t(engine) }}
            </option>
          </b-select>
        </b-field>
        <b-field
          v-if="section.mode === 'car' || section.mode === 'motorbike'"
          :label="
            section.mode === 'car'
              ? $t('compCarbonFormsCommutesForm.n-persons-car') + ' *'
              : $t('compCarbonFormsCommutesForm.n-persons-2weels') + ' *'
          "
          :type="{ 'is-danger': errors.has(section.mode + '.pooling1') }"
          :message="errors.first(section.mode + '.pooling1')"
        >
          <b-input
            :name="section.mode + '.pooling1'"
            @input="$emit('input', buffer)"
            v-validate="{
              required: true,
              numeric: true,
              min_value: 1,
              max_value: poolingMaxValue(section.mode)
            }"
            min="1"
            v-model="section.pooling"
            type="number"
            expanded
          >
          </b-input>
        </b-field>
      </b-notification>
      <br />
    </div>
    <div v-if="activeStep === 2">
      <div class="columns">
        <div class="column is-3 is-offset-3">
          <b-button
            expanded
            @click="$emit('updateHasWorkingDay2', true)"
            :type="hasWorkingDay2 ? 'is-primary is-light' : ''"
          >
            {{ $t('yes') }}
          </b-button>
        </div>
        <div class="column is-3">
          <b-button
            expanded
            @click="$emit('updateHasWorkingDay2', false)"
            :type="!hasWorkingDay2 ? 'is-primary is-light' : ''"
          >
            {{ $t('no') }}
          </b-button>
        </div>
      </div>
      <br />
    </div>
    <b-notification
      v-if="activeStep === 3"
      :type="errors.has('nWorkingDay2') ? 'is-danger' : ''"
      :closable="false"
    >
      <b-field
        :type="{ 'is-danger': errors.has('nWorkingDay2') }"
        :message="errors.first('nWorkingDay2')"
      >
        <b-select
          name="nWorkingDay2"
          v-validate="'required'"
          @input="$emit('input', buffer)"
          v-model="buffer.nWorkingDay2"
          :type="{ 'is-danger': errors.has('nWorkingDay2') }"
          :placeholder="
            $t('compCarbonFormsCommutesForm.nb-day-per-week') + ' *'
          "
          expanded
        >
          <option
            v-for="(nbJ, index) in buffer.nWorkingDay - 1"
            :key="index"
            :value="nbJ"
          >
            {{ nbJ }}
            <span v-if="nbJ > 1">{{
              $t('compCarbonFormsCommutesForm.days-per-week')
            }}</span>
            <span v-else>{{
              $t('compCarbonFormsCommutesForm.day-per-week')
            }}</span>
          </option>
        </b-select>
      </b-field>
    </b-notification>
    <div v-if="activeStep === 4" :type="noMode2Selected ? 'is-danger' : ''">
      <div class="columns is-multiline is-centered">
        <div
          v-for="(mode, index) in TRAVELS_MODES"
          :key="index"
          class="column is-3"
        >
          <button
            class="button is-mode-deplacement is-fullwidth"
            type="button"
            :class="{
              'is-primary is-light': buffer.hasMode(mode, true),
              'is-danger': noMode2Selected
            }"
            @click="selectMode2(mode)"
          >
            <b-icon
              :pack="modeIconPack(mode)"
              :icon="modeIcon(mode)"
              style="padding-right: 20px"
            />
            <span> {{ $t(mode) }} </span>
          </button>
        </div>
      </div>
      <br />
    </div>
    <div v-if="activeStep === 5">
      <b-notification :closable="false">
        {{ $t('compCarbonFormsCommutesForm.header-1') }}
        <a
          target="_blank"
          class="link"
          href="https://www.openstreetmap.org/directions"
          >openstreetmap</a
        >.
        {{ $t('compCarbonFormsCommutesForm.header-2') }}
        <br />
        {{ $t('compCarbonFormsCommutesForm.header-3') }}
      </b-notification>
      <b-notification
        v-for="(section, index) in buffer.sections.filter(
          (section) => section.isDay2
        )"
        :type="
          errors.has(section.mode + '2') ||
          errors.has(section.mode + '.engine2') ||
          errors.has(section.mode + '.pooling2')
            ? 'is-danger'
            : ''
        "
        :closable="false"
        :key="index"
      >
        <b-field
          :label="
            $t('compCarbonFormsCommutesForm.distance-in') +
            ' ' +
            $t(section.mode).toLowerCase() +
            ' (' +
            $t('compCarbonFormsCommutesForm.km-day') +
            ')' +
            ' *'
          "
          :type="{ 'is-danger': errors.has(section.mode + '2') }"
          :message="errors.first(section.mode + '2')"
        >
          <b-input
            :name="section.mode + '2'"
            @input="$emit('input', buffer)"
            v-validate="{
              required: true,
              numeric: true,
              min_value: 1,
              max_value: modeMaxDistance(section.mode)
            }"
            min="0"
            :icon="modeIcon(section.mode)"
            :icon-pack="modeIconPack(section.mode)"
            type="number"
            :placeholder="0"
            v-model="section.distance"
          />
        </b-field>
        <b-field
          v-if="section.mode === 'car'"
          :label="$t('compCarbonFormsCommutesForm.engine') + ' *'"
          :type="{ 'is-danger': errors.has(section.mode + '.engine2') }"
          :message="errors.first(section.mode + '.engine2')"
        >
          <b-select
            :name="section.mode + '.engine2'"
            v-model="section.engine"
            @input="$emit('input', buffer)"
            v-validate="'required'"
            :placeholder="$t('compCarbonFormsCommutesForm.engine') + ' *'"
            :type="errors.has(section.mode + '.engine2') ? 'is-danger' : ''"
            expanded
          >
            <option
              :value="engine"
              v-for="(engine, index) in engines"
              :key="index"
            >
              {{ $t(engine) }}
            </option>
          </b-select>
        </b-field>
        <b-field
          v-if="section.mode === 'car' || section.mode === 'motorbike'"
          :label="
            section.mode === 'car'
              ? $t('compCarbonFormsCommutesForm.n-persons-car') + ' *'
              : $t('compCarbonFormsCommutesForm.n-persons-2weels') + ' *'
          "
          :type="{ 'is-danger': errors.has(section.mode + '.pooling2') }"
          :message="errors.first(section.mode + '.pooling2')"
        >
          <b-input
            :name="section.mode + '.pooling2'"
            @input="$emit('input', buffer)"
            v-validate="{
              required: true,
              numeric: true,
              min_value: 1,
              max_value: poolingMaxValue(section.mode)
            }"
            min="1"
            v-model="section.pooling"
            type="number"
            expanded
          >
          </b-input>
        </b-field>
      </b-notification>
      <br />
    </div>
    <div class="columns">
      <div class="column">
        <b-button
          class="button is-fullwidth"
          @click="previousStep"
          data-testid="previous-step"
          icon-left="angle-double-left"
        >
          {{ $t('previous') }}
        </b-button>
      </div>
      <div class="column">
        <b-button
          class="button is-fullwidth is-primary"
          @click="nextStep"
          data-testid="next-step-commutes"
          icon-right="angle-double-right"
        >
          {{ nextBtnLabel }}
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
import Commute from '@/models/carbon/Commute.js'
import Vehicle from '@/models/carbon/Vehicle.js'

export default {
  name: 'Form',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    year: {
      type: Number,
      default: new Date().getFullYear() - 1
    },
    isSurvey: {
      type: Boolean,
      default: false
    },
    isSimulation: {
      type: Boolean,
      default: false
    },
    hasWorkingDay2: {
      type: Boolean,
      default: false
    },
    totalStep: {
      type: Number,
      default: 7
    },
    startStep: {
      type: Number,
      default: 0
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      TRAVELS_MODES: Commute.TRAVELS_MODES,
      buffer: Commute.createFromObj(this.value),
      activeStep: 0,
      noMode1Selected: false,
      noMode2Selected: false
    }
  },
  computed: {
    progressValue: function () {
      return ((this.activeStep + this.startStep) / this.totalStep) * 100
    },
    engines: function () {
      return Vehicle.getEngines('car')
    },
    nextBtnLabel: function () {
      if (!this.isSimulation && this.isSurvey && this.progressValue === 100) {
        return this.$t('preview')
      }
      if (this.isSimulation && this.progressValue === 100) {
        return this.$t('add-simu')
      }
      if (!this.isSimulation && !this.isSurvey && this.progressValue === 100) {
        return this.$t('compCarbonFormsCommutesForm.add')
      } else {
        return this.$t('next')
      }
    },
    activeQuestion: function () {
      if (this.activeStep === 0) {
        return (
          this.$t('compCarbonFormsCommutesForm.question-1-1') +
          this.year +
          this.$t('compCarbonFormsCommutesForm.question-1-2')
        )
      } else if (this.activeStep === 1) {
        return (
          this.$t('compCarbonFormsCommutesForm.question-2-1') +
          this.year +
          this.$t('compCarbonFormsCommutesForm.question-2-2')
        )
      } else if (this.activeStep === 2) {
        return (
          this.$t('compCarbonFormsCommutesForm.question-3') +
          ' ' +
          this.year +
          ' ?'
        )
      } else if (this.activeStep === 3) {
        return (
          this.$t('compCarbonFormsCommutesForm.question-4-1') +
          ' ' +
          this.buffer.nWorkingDay +
          ' ' +
          this.$t('compCarbonFormsCommutesForm.question-4-2')
        )
      } else if (this.activeStep === 4) {
        return (
          this.$t('compCarbonFormsCommutesForm.question-5') +
          ' ' +
          this.year +
          ' ?'
        )
      } else if (this.activeStep === 5) {
        return (
          this.$t('compCarbonFormsCommutesForm.question-6') +
          ' ' +
          this.year +
          ' ?'
        )
      } else {
        return ''
      }
    }
  },
  methods: {
    modeIcon: function (mode) {
      return Commute.ICONS(mode)
    },
    modeIconPack: function (mode) {
      return Commute.ICONS_PACK(mode)
    },
    poolingMaxValue: function (mode) {
      if (mode === 'motorbike') {
        return 3
      } else {
        return 10
      }
    },
    modeMaxDistance: function (mode) {
      return Commute.MAX_DISTANCES(mode)
    },
    selectMode1 (mode) {
      if (this.buffer.hasMode(mode)) {
        this.buffer.removeSection(mode)
      } else {
        this.buffer.addSection({
          mode: mode,
          distance: 0,
          isDay2: false,
          pooling: 1,
          engine: null
        })
        this.noMode1Selected = false
      }
      this.$emit('input', this.buffer)
    },
    selectMode2 (mode) {
      if (this.buffer.hasMode(mode, true)) {
        this.buffer.removeSection(mode, true)
      } else {
        this.buffer.addSection({
          mode: mode,
          distance: 0,
          isDay2: true,
          pooling: 1,
          engine: null
        })
        this.noMode2Selected = false
      }
      this.$emit('input', this.buffer)
    },
    nextStep () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.activeStep === 0) {
            if (this.buffer.hasSections()) {
              this.activeStep += 1
            } else {
              this.noMode1Selected = true
            }
          } else if (this.activeStep === 1 && this.buffer.nWorkingDay === 1) {
            this.$emit('input', this.buffer)
            this.$emit('submit')
          } else if (this.activeStep === 2) {
            if (this.hasWorkingDay2) {
              this.activeStep += 1
            } else {
              this.buffer.removeAllSectionsDay2()
              this.$emit('input', this.buffer)
              this.$emit('submit')
            }
          } else if (this.activeStep === 4) {
            if (this.buffer.hasSections(true)) {
              this.activeStep += 1
            } else {
              this.noMode2Selected = true
            }
          } else if (this.activeStep === 5) {
            this.$emit('input', this.buffer)
            this.$emit('submit')
          } else {
            this.activeStep += 1
          }
        }
      })
    },
    previousStep () {
      if (this.activeStep > 0) {
        this.activeStep -= 1
      } else {
        this.$emit('back')
      }
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Commute.createFromObj(this.value)
      },
      deep: true
    }
  }
}
</script>

<style>
.notification.is-danger {
  background-color: #fbf4f6 !important;
}
.button.is-primary.is-light {
  background-color: #e5f0fb !important;
  color: #296fa8 !important;
}
.button.is-danger.is-light {
  background-color: #fde0e6 !important;
  color: #cc0f35 !important;
}
.button.is-mode-deplacement {
  padding: 50px;
  font-size: 18px;
  white-space: normal;
}
.button.is-mode-deplacement.is-danger {
  background-color: #fde0e6;
  border-color: transparent;
  color: #cc0f35;
}
</style>
